import { BaseAppModel } from '@/common/models/AppModel';
import { insetVerticalScrollbar } from '@/common/styles/scrollArea';
import { colors, fullSize, ScrollArea, standardSizes, Tab } from '@toilet-paper-games/ui';
import { observer } from 'mobx-react-lite';
import TPIcon from '#/tp.png';
import { DEV_GAME_ID } from '@/common/constants';
import { GameIconButton } from './GameIconButton';
import { GameIconInfo, GameListViewModel } from './GameList';

export interface FilteredGamesListProps<T extends BaseAppModel> {
  filter?: (game: GameIconInfo) => boolean;
  viewModel: GameListViewModel<T>;
  onGameSelected?: (gameUniqueName: string) => void;
  plain?: boolean;
}

export const gameTagFilter = (tags: string[]) => (game: GameIconInfo) =>
  tags.some((tag) => game.tags.includes(tag));

export const FilteredGameList = observer(
  ({
    viewModel,
    filter = () => true,
    onGameSelected,
    plain = false,
  }: FilteredGamesListProps<BaseAppModel>) => {
    const content = (
      <ScrollArea css={insetVerticalScrollbar} hideScrollBackground type="hover">
        <div
          css={[
            {
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(128px, 1fr))',
              padding: 33,
              gap: standardSizes.lg,
            },
          ]}
        >
          {viewModel.gameIconInfoList
            .filter(filter)
            .map(({ uniqueName, displayName, image }) => (
              <GameIconButton
                key={uniqueName}
                uniqueName={uniqueName}
                title={displayName}
                image={image ?? TPIcon}
                onClick={() => {
                  viewModel.selectGame(uniqueName);
                  onGameSelected?.(uniqueName);
                }}
                css={uniqueName === DEV_GAME_ID && { borderColor: colors.danger }}
              />
            ))}
        </div>
      </ScrollArea>
    );

    return plain ? (
      <div css={[fullSize]}>{content}</div>
    ) : (
      <Tab css={{ padding: 0 }}>{content}</Tab>
    );
  },
);
